import React from 'react';
import { I18n } from 'js/components/common/I18n';
import { clsb, clsx } from 'js/utils/classNames.util';

import * as Types from './types';

import style from './ErrorMessage.scss';

export const ErrorMessage: React.FC<RequireOnlyOne<Types.IErrorMessageProps, 'message' | 'error'>> = ({
    error,
    message,
    classNames = {},
    className = '',
    animate = false
}) => {
    const errorMessageClassName = clsx([
        clsb([style, classNames], ['error']),
        className,
        animate ? 'slideInDown' : ''
    ]);

    if (React.isValidElement(error)) {
        return <div className={errorMessageClassName}>{error}</div>;
    }

    const errorMessage = error as string || message || 'playtech.mobile.system.error.default';

    return (
        <I18n
            tagName={'div'}
            tKey={errorMessage}
            defaultValue={errorMessage}
            className={errorMessageClassName}
        />
    );
};
